module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row form"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_make"
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.make),
      expression: "trailer.make"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Make",
      "id": "addAsset_make",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.make)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "make", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_model"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.model),
      expression: "trailer.model"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Model",
      "id": "addAsset_model",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_ID"
    }
  }, [_vm._v("Asset ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.assetId),
      expression: "trailer.assetId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_ID",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.assetId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "assetId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techprovider"
    }
  }, [_vm._v("Tech Provider")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.techProvider),
      expression: "trailer.techProvider"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_techprovider",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trailer, "techProvider", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dummyTracker"
    }
  }, [_vm._v("Dummy Tracker")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bluerover"
    }
  }, [_vm._v("BlueRover")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.techProviderId),
      expression: "trailer.techProviderId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.techProviderId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "techProviderId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_trailertype"
    }
  }, [_vm._v("Trailer Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.trailerType),
      expression: "trailer.trailerType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_trailertype",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trailer, "trailerType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DryVan"
    }
  }, [_vm._v("Dry Van")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Flatbed"
    }
  }, [_vm._v("Flatbed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ContainerChassis"
    }
  }, [_vm._v("Container Chassis")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_length"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.length),
      expression: "trailer.length"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Length",
      "id": "addAsset_length",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "length", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_liftgate"
    }
  }, [_vm._v("Lift Gate")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.liftGate),
      expression: "trailer.liftGate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_liftgate",
      "name": "Lift Gate",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trailer, "liftGate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "No"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_suspension"
    }
  }, [_vm._v("Suspension Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.suspension),
      expression: "trailer.suspension"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_suspension",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trailer, "suspension", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Spring"
    }
  }, [_vm._v("Spring")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_tare"
    }
  }, [_vm._v("Tare Weight")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.tareWeight),
      expression: "trailer.tareWeight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Tare Weight",
      "id": "addAsset_tare",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.tareWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "tareWeight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_gross"
    }
  }, [_vm._v("Gross Weight")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.grossWeight),
      expression: "trailer.grossWeight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Gross Weight",
      "id": "addAsset_gross",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.grossWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "grossWeight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_GIAI"
    }
  }, [_vm._v("GIAI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.giai),
      expression: "trailer.giai"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_GIAI",
      "placeholder": "",
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.giai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer, "giai", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_refrigeration"
    }
  }, [_vm._v("Refrigeration Unit")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.refrigerationUnit),
      expression: "trailer.refrigerationUnit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_refrigeration",
      "name": "Refrigeration Unit",
      "disabled": _vm.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trailer, "refrigerationUnit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "No"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-white mb-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Refrigeration Unit Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.ru.make),
      expression: "trailer.ru.make"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "refrigeration unit's Make",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.ru.make)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer.ru, "make", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.ru.model),
      expression: "trailer.ru.model"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "refrigeration unit's Model",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.ru.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer.ru, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Engine Type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.ru.engineType),
      expression: "trailer.ru.engineType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "refrigeration unit's Engine Type",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.ru.engineType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer.ru, "engineType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Emissions Profile")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailer.ru.emissionsProfile),
      expression: "trailer.ru.emissionsProfile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0'),
      expression: "'required|min_value:0'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "refrigeration unit's Emissions Profile",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": !_vm.hasRefrigerationUnit || _vm.readonly
    },
    domProps: {
      "value": (_vm.trailer.ru.emissionsProfile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trailer.ru, "emissionsProfile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon su-group-addon"
  }, [_vm._v("g CO2 per ton-mile")])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c2d4627"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/asset/TrailerForm.vue
// module id = 682
// module chunks = 0